import {combineReducers} from 'redux'
import {ageReducer} from './ageReducer'
import { rewardReducer } from './rewardReducer'
import { signInReducer } from './signinReducer'
import { idcardDetection } from './idcardocr.reducer'

export default combineReducers({
    ageReducer,
    alertRewardRedeem: rewardReducer,
    signInReducer,
    idcardDetection
})